'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var response = void 0;

    if (raw && raw.status !== 'success') {
        response = Object.assign({}, raw, {
            status: responseState.ERROR,
            message: raw.message,
            name: raw.param,
            data: raw.data
        });
    } else {
        response = {
            status: responseState.SUCCESS,
            data: raw ? raw.data : raw
        };
    }

    return response;
};

var responseState = {
    SUCCESS: 'success',
    ERROR: 'error'
};